import axios from 'axios'
import qs from 'qs'

// axios全局配置
axios.defaults.withCredentials = true;   //`withCredentials` 表示跨域请求时是否需要使用凭证

// 路径配置
let apiHost = window.location.host;

const api = {
  methods: {
    post(url, params) {
      let promiseXHR = new Promise((resolve, reject) => {
        axios.post(url, qs.stringify(params)).then(
          (response) => {
            resolve(response.data)
          },
          (error) => {
            reject(error)
          }
        )
      })
      return promiseXHR
    },
    get(url) {
      let promiseXHR = new Promise((resolve, reject) => {
        axios.get(url).then(
          (response) => {
            resolve(response.data)
          },
          (error) => {
            reject(error)
          }
        )
      })
      return promiseXHR
    },
    // oss上传相关
    // 获取上传OSS签名数据
    async getUploadSign(dir = 'doctor') {
      let now = new Date().getTime() / 1000;
      if(this.$store.state.uploadParams.expire < now + 3) {
        // 同步请求
        let data = await this.get(`/getWebUploadSign?dir=${dir}`)
        // let signData = JSON.parse(data)
        // 格式化签名数据
        let formatSignData = {
          host: data.host,
          policyBase64: data.policy,
          accessid: data.accessid,
          signature: data.signature,
          expire: parseInt(data.expire),
          callback: data.callback,
          key: data.dir,
        }
        // 保存到store
        this.$store.commit('setUploadParams', formatSignData);
        return true;
      }else {
        return false;
      }
    },
    // 设置上传OSS参数
    async setUploadParam(uploader, filename, ret, dir) {
      if(ret == false) {
        // 同步请求
        ret = await this.getUploadSign(dir);
      }
      let optionKey = ''
      if(filename != '') {
        optionKey = this.randomName(filename);
      }else {
        optionKey = this.$store.state.uploadParams.key + '${filename}';
      }
      let multipartParams = {
        policy: this.$store.state.uploadParams.policyBase64,
        OSSAccessKeyId: this.$store.state.uploadParams.accessid,
        success_action_status: '200',
        callback: this.$store.state.uploadParams.callback,
        signature: this.$store.state.uploadParams.signature,
        key: optionKey
      }
      uploader.setOption({
        url: this.$store.state.uploadParams.host,
        multipart_params: multipartParams
      });
      uploader.start();
    },
    // 生成随机文件名
    randomName(filename) {
      // 生成随机字符串
      let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
      let maxPos = chars.length;
      let pwd = '';
      for (let i = 0; i < 32; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      // 获取文件后缀
      let suffix = '';
      let pos = filename.lastIndexOf('.');
      if(pos != -1) {
        suffix = filename.substring(pos);
      }
      return this.$store.state.uploadParams.key + pwd + suffix;
    },
    // 生成随机文件名
    randomString() {
      // 生成随机字符串
      let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz0123456789_';
      let maxPos = chars.length;
      let pwd = '';
      for (let i = 0; i < 32; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return  pwd ;
    },
    previewUploadImage(file, callback) {
      //file为plupload事件监听函数参数中的file对象,callback为预览图片准备完成的回调函数
      if(!file || !/image\//.test(file.type)) return; //确保文件是图片
      if(file.type=='image/gif') {
        //gif使用FileReader进行预览,因为mOxie.Image只支持jpg和png
        let fr = new moxie.file.FileReader();
        fr.onload = () => {
          callback(fr.result);
          fr.destroy();
          fr = null;
        }
        fr.readAsDataURL(file.getSource());
      }else {
        var preloader = new moxie.image.Image();
        preloader.onload = () => {
          // preloader.downsize( 300, 300 ); //先压缩一下要预览的图片,宽300，高300
          var imgsrc = preloader.type=='image/jpeg' ? preloader.getAsDataURL('image/jpeg', 80) : preloader.getAsDataURL(); //得到图片src,实质为一个base64编码的数据
          callback && callback(imgsrc); //callback传入的参数为预览图片的url
          preloader.destroy();
          preloader = null;
        }
        preloader.load( file.getSource() );
      }
    },
  }
}

export default api



// WEBPACK FOOTER //
// ./src/untils/http.js